export let currentInstance = null;

export function setCurrentInstance(instance) {
  currentInstance = instance;
}